import { PublicClientApplication } from "@azure/msal-browser";
import config from "../../config";
const msalConfig = {
    auth: {
        clientId: config.CLIENTID,
        authority: config.AUTHORITY,
        redirectUri: config.REDIRECTURI,
        postLogoutRedirectUri: config.POSTLOGOUTREDIRECTURI,
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    }
};
const msalInstance = new PublicClientApplication(msalConfig);
export default msalInstance;